

import HelperEnv from '../helpers/HelperEnv';
import HelperApis from '../helpers/HelperApis';
import HelperContext from '../helpers/HelperContext';

/*
 * action types
 */

export const REQUEST_POSTS_VERSION = 'REQUEST_POSTS_VERSION';
export const RECEIVE_POSTS_VERSION = 'RECEIVE_POSTS_VERSION';
export const REJECT_POSTS_VERSION = 'REJECT_POSTS_VERSION';

export const REQUEST_POSTS_ROUTINGINFO = 'REQUEST_POSTS_ROUTINGINFO';
export const RECEIVE_POSTS_ROUTINGINFO = 'RECEIVE_POSTS_ROUTINGINFO';
export const REJECT_POSTS_ROUTINGINFO = 'REJECT_POSTS_ROUTINGINFO';

export const VEHICLE_SET_LOADING = 'VEHICLE_SET_LOADING';
export const REJECT_POSTS_UNAUTHORISED = 'REJECT_POSTS_UNAUTHORISED';

/*
 * action creators
 */
export function setLoadVehicle(vehicleExamplesLoadedOnce) {
	return { type: VEHICLE_SET_LOADING, payload: { vehicleExamplesLoadedOnce } }
}

export function fetchRoutingInfoIfNeeded(dispatch, globalstate, context) {
	if (context == null && globalstate.testCriteria.context != null) {
		context = globalstate.testCriteria.context;
	}
	return fetchRoutingInfo(dispatch, context, globalstate.env);
}

/*
 * internal action creators
 */
function requestPostsVersion() {
	return { type: REQUEST_POSTS_VERSION }
}
function rejectPostsVersion() {
	return { type: REJECT_POSTS_VERSION }
}
function receivePostsVersion(version) {
	return {
		type: RECEIVE_POSTS_VERSION,
		payload: { version }
	}
}

function requestPostsRoutingInfo() {
	return { type: REQUEST_POSTS_ROUTINGINFO }
}
function rejectPostsRoutingInfo() {
	return { type: REJECT_POSTS_ROUTINGINFO }
}
function receivePostsRoutingInfo(routingInfo) {
	return {
		type: RECEIVE_POSTS_ROUTINGINFO,
		payload: { routingInfo }
	}
}

export function rejectPostsUnauthorised(status) {
	return { type: REJECT_POSTS_UNAUTHORISED, payload: { status } }
}

export function fetchVersion(dispatch) {
	dispatch(requestPostsVersion());
	var configEnv = HelperEnv.getPathEnvVariables().urlBaseAppIntranet;
	var url = configEnv + HelperEnv.getUriVersion();
	fetch(url, {
		method: 'get',
		headers: HelperApis.getHeadersBasis()
	}).then(res => {
		if (res.status !== 200) {
			dispatch(rejectPostsUnauthorised({ resHttpStatus: res.status, statusText: res.statusText }));
		}
		if (!res.ok) {
			dispatch(rejectPostsVersion());
		} else {
			return res.json()
		}
		return null;
	}).catch((error) => {
		dispatch(rejectPostsUnauthorised({ error: error }));
	}).then(json => { dispatch(receivePostsVersion(json)) });
}
function fetchRoutingInfo(dispatch, context, env) {
	dispatch(requestPostsRoutingInfo());
	var configEnv = HelperEnv.getPathEnvVariables().urlBaseAppIntranet;
	var distributionBrand = context.distributionBrand;
	var countryCode = context.countryCode;
	var customerMarket = HelperContext.getCustomerMarket(context.customer.clientType);
	var url = configEnv + HelperEnv.getUriRoutingInformation(distributionBrand, countryCode, customerMarket);
	var headers = {
		...HelperApis.getHeadersBasis(),
		'X-siteCode': context.siteCode,
		'X-componentCode': 'GWTEST'
	};
	if(context.journeyType) {
		headers = {...headers, 'X-journeyType': context?.journeyType}
	}
	if(context.financeJourneyCode){
		headers['X-financeJourneyCode'] = context.financeJourneyCode;
	}
	fetch(url, {
		method: 'get',
		headers: headers,
		body: JSON.stringify()
	}).then(res => {
		if (res.status !== 200) {
			dispatch(rejectPostsUnauthorised({ resHttpStatus: res.status, statusText: res.statusText }));
		}
		if (!res.ok) {
			dispatch(rejectPostsRoutingInfo());
		} else {
			return res.json()
		}
		return null;
	}).catch((error) => {
		dispatch(rejectPostsUnauthorised({ error: error }));
	}).then(json => {
		dispatch(receivePostsRoutingInfo(json))
	});
}
